import { useState, useEffect } from "react";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import { FaUserShield, FaUserCog, FaUserTie } from "react-icons/fa";
import "./admin.css";
import useModal from '../Modal/useModal';
import Modal from '../Modal/modal';
import axios from 'axios';
import { API_URL } from "../constants";
import capteur from "../icons/capteur.png";
import capteur2 from "../icons/capteur2.png";
import { UserTypes } from "../constants";

export default function UserTable({ users, deleteUser, setSelectedUserId, setSelectedUserEmail, rafraichir, token }) {
  const user = JSON.parse(localStorage.getItem("user"));
  const { isShowing: isSuppModalShowing, toggle: toggleSuppModal } = useModal();
  const [selectedAgency, setSelectedAgency] = useState("");
  const [agencies, setAgencies] = useState([]);
  const [agencyUsers, setAgencyUsers] = useState({});
  const [usersInSelectedAgency, setUsersInSelectedAgency] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const userType = user.type;
  const isAdmin = userType === UserTypes.ADMIN;
  const [userToDelete, setUserToDelete] = useState({ mail: "", id: "" });

  const handleConfirmation = (userId, emailUtilisateur) => {
    deleteUser(userId, { mail: emailUtilisateur });
    toggleSuppModal();
  };

  const toggleSms = (userId, currentValue) => {
    axios.patch(
      `${API_URL}/users/${userId}`,
      { sms: !currentValue },
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      }
    )
      .then(() => rafraichir())
      .catch(error => {
        if (error.response?.status === 401) {
          localStorage.clear();
          window.location.href = '/login';
        }
      });
  };

  useEffect(() => {
    const fetchAgenciesAndUsers = async () => {
      try {
        const agenciesResponse = await axios.get(`${API_URL}/agences?limit=1000&offset=0`, {
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
        });
        const agencies = agenciesResponse.data.data;
        setAgencies(agencies);

        const updatedAgencyUsers = {};
        for (const agency of agencies) {
          const usersResponse = await axios.get(`${API_URL}/agences/${agency.id}/users`, {
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token }
          });
          updatedAgencyUsers[agency.id] = usersResponse.data.data.filter(user => {
            for (const agencyId in updatedAgencyUsers) {
              if (agencyId !== agency.id && updatedAgencyUsers[agencyId].find(u => u.id === user.id)) return false;
            }
            return true;
          });
        }

        updatedAgencyUsers[""] = users;
        setAgencyUsers(updatedAgencyUsers);
        setUsersInSelectedAgency(selectedAgency ? (updatedAgencyUsers[selectedAgency] || []) : users);
      } catch (error) {
        console.error("Erreur agences/utilisateurs :", error.message);
      }
    };
    fetchAgenciesAndUsers();
  }, [selectedAgency, users, token]);

  useEffect(() => {
    setFilteredUsers(usersInSelectedAgency.filter(u => {
      if ((u.type === 0 && isAdmin) || (u.type === 4 && isAdmin)) return false;
      return true;
    }));
  }, [usersInSelectedAgency, isAdmin]);

  const getAccessLevelIcon = (type) => {
    switch (type) {
      case 0: return <FaUserShield className="text-red-400 text-lg" />;
      case 1: return <FaUserCog className="text-yellow-500 text-lg" />;
      case 2: return <FaUserTie className="text-green-500 text-lg" />;
      case 3: return <FaUserTie className="text-blue-500 text-lg" />;
      case 4: return <img src={capteur2} alt="Capteur" className="w-5 inline-block" />;
      default: return null;
    }
  };

  const getAccessLevelLabel = (type) => {
    switch (type) {
      case 0: return "SuperAdmin";
      case 1: return "Admin";
      case 2: return "Chef d'agence";
      case 3: return "Chef d'atelier";
      case 4: return "Capteur";
      default: return "—";
    }
  };

  const getAgencyName = (userId) => {
    for (const agencyId in agencyUsers) {
      const matched = agencyUsers[agencyId]?.find(u => u.id === userId);
      if (matched) {
        const agency = agencies.find(a => a.id === agencyId);
        return agency ? agency.nom : "";
      }
    }
    return "";
  };

  return (
    <div>
      {/* Filtre agence */}
      <div className="px-5 pt-5 pb-4 border-b border-gray-100">
        <select
          value={selectedAgency}
          onChange={(e) => setSelectedAgency(e.target.value)}
          className="w-full sm:w-auto border border-gray-200 rounded-xl px-4 py-2.5 text-base bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-loginBordure/30 focus:border-loginBordure transition"
        >
          <option value="">Toutes les agences</option>
          {agencies.map(a => (
            <option key={a.id} value={a.id}>{a.nom}</option>
          ))}
        </select>
      </div>

      {/* Tableau desktop */}
      <div className="hidden sm:block overflow-x-auto">
        <table className="w-full text-base">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100">
              <th className="px-5 py-4 text-left text-sm font-semibold text-gray-500 uppercase tracking-wide">Nom</th>
              <th className="px-5 py-4 text-left text-sm font-semibold text-gray-500 uppercase tracking-wide">Prénom</th>
              <th className="px-5 py-4 text-left text-sm font-semibold text-gray-500 uppercase tracking-wide">Agence</th>
              <th className="px-5 py-4 text-left text-sm font-semibold text-gray-500 uppercase tracking-wide">Email</th>
              <th className="px-5 py-4 text-left text-sm font-semibold text-gray-500 uppercase tracking-wide">Accès</th>
              <th className="px-5 py-4 text-center text-sm font-semibold text-gray-500 uppercase tracking-wide">SMS</th>
              <th className="px-5 py-4" />
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {filteredUsers.map(currentUser => (
              <tr key={currentUser.id} className="hover:bg-gray-50 transition-colors group">
                <td className="px-5 py-4 text-gray-800 font-medium">{currentUser.nom}</td>
                <td className="px-5 py-4 text-gray-700">{currentUser.prenom}</td>
                <td className="px-5 py-4 text-gray-500 text-sm">{getAgencyName(currentUser.id) || <span className="italic text-gray-300">—</span>}</td>
                <td className="px-5 py-4 text-gray-600 text-sm">{currentUser.mail}</td>
                <td className="px-5 py-4">
                  <span className="inline-flex items-center gap-2 text-sm text-gray-600">
                    {getAccessLevelIcon(currentUser.type)}
                    {getAccessLevelLabel(currentUser.type)}
                  </span>
                </td>
                <td className="px-5 py-4 text-center">
                  <button
                    type="button"
                    onClick={() => toggleSms(currentUser.id, currentUser.sms)}
                    title={currentUser.sms ? "Désactiver SMS" : "Activer SMS"}
                    className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-1
                      ${currentUser.sms ? 'bg-emerald-500 focus:ring-emerald-400' : 'bg-gray-200 focus:ring-gray-300'}`}
                  >
                    <span
                      className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow transition-transform duration-200
                        ${currentUser.sms ? 'translate-x-4' : 'translate-x-1'}`}
                    />
                  </button>
                </td>
                <td className="px-5 py-4">
                  <div className="flex items-center gap-4 justify-end opacity-0 group-hover:opacity-100 transition-opacity">
                    <button
                      onClick={() => { setSelectedUserId(currentUser.id); setSelectedUserEmail(currentUser.mail); }}
                      title="Modifier"
                      className="text-gray-400 hover:text-loginBordure transition text-lg"
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => { setUserToDelete({ mail: currentUser.mail, id: currentUser.id }); toggleSuppModal(); }}
                      title="Supprimer"
                      className="text-gray-400 hover:text-red-500 transition text-lg"
                    >
                      <FaTrashAlt />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
            {filteredUsers.length === 0 && (
              <tr>
                <td colSpan={7} className="px-5 py-10 text-center text-base text-gray-400 italic">Aucun utilisateur trouvé</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Cartes mobile */}
      <div className="sm:hidden divide-y divide-gray-100">
        {filteredUsers.map(currentUser => (
          <div key={currentUser.id} className="px-5 py-4 flex items-center justify-between gap-4">
            <div className="flex flex-col gap-1 min-w-0">
              <span className="text-base font-semibold text-gray-700 truncate">
                {currentUser.nom} {currentUser.prenom}
              </span>
              <span className="text-sm text-gray-400 truncate">{currentUser.mail}</span>
              <span className="inline-flex items-center gap-1.5 text-sm text-gray-500 mt-0.5">
                {getAccessLevelIcon(currentUser.type)}
                {getAccessLevelLabel(currentUser.type)}
              </span>
            </div>
            <div className="flex items-center gap-4 shrink-0">
              <button
                type="button"
                onClick={() => toggleSms(currentUser.id, currentUser.sms)}
                title={currentUser.sms ? "Désactiver SMS" : "Activer SMS"}
                className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors duration-200 focus:outline-none
                  ${currentUser.sms ? 'bg-emerald-500' : 'bg-gray-200'}`}
              >
                <span
                  className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white shadow transition-transform duration-200
                    ${currentUser.sms ? 'translate-x-4' : 'translate-x-1'}`}
                />
              </button>
              <button
                onClick={() => { setSelectedUserId(currentUser.id); setSelectedUserEmail(currentUser.mail); }}
                className="text-gray-400 hover:text-loginBordure transition text-xl"
              >
                <FaEdit />
              </button>
              <button
                onClick={() => { setUserToDelete({ mail: currentUser.mail, id: currentUser.id }); toggleSuppModal(); }}
                className="text-gray-400 hover:text-red-500 transition text-xl"
              >
                <FaTrashAlt />
              </button>
            </div>
          </div>
        ))}
        {filteredUsers.length === 0 && (
          <p className="px-5 py-10 text-center text-base text-gray-400 italic">Aucun utilisateur trouvé</p>
        )}
      </div>

      {/* Légende */}
      <div className="px-5 py-4 border-t border-gray-100 flex flex-wrap gap-x-5 gap-y-2">
        {!isAdmin && (
          <span className="inline-flex items-center gap-2 text-sm text-gray-500">
            <FaUserShield className="text-red-400 text-base" /> SuperAdmin
          </span>
        )}
        <span className="inline-flex items-center gap-2 text-sm text-gray-500">
          <FaUserCog className="text-yellow-500 text-base" /> Admin
        </span>
        <span className="inline-flex items-center gap-2 text-sm text-gray-500">
          <FaUserTie className="text-green-500 text-base" /> Chef d'agence
        </span>
        <span className="inline-flex items-center gap-2 text-sm text-gray-500">
          <FaUserTie className="text-blue-500 text-base" /> Chef d'atelier
        </span>
        {!isAdmin && (
          <span className="inline-flex items-center gap-2 text-sm text-gray-500">
            <img src={capteur} alt="Capteur" className="w-4" /> Capteur
          </span>
        )}
      </div>

      {/* Modal suppression */}
      <Modal isShowing={isSuppModalShowing} hide={toggleSuppModal} title="Confirmation de suppression">
        <p className="text-center text-base text-gray-600 mb-1">Supprimer l'utilisateur</p>
        <p className="text-center font-semibold text-gray-800 text-lg mb-6">{userToDelete.mail}</p>
        <div className="flex gap-3">
          <button
            className="flex-1 px-4 py-3 border border-gray-200 text-gray-600 text-base font-semibold rounded-xl hover:bg-gray-50 transition cursor-pointer"
            onClick={toggleSuppModal}
          >
            Annuler
          </button>
          <button
            className="flex-1 px-4 py-3 bg-red-500 hover:bg-red-600 text-white text-base font-semibold rounded-xl transition cursor-pointer border-none"
            onClick={() => handleConfirmation(userToDelete.id, userToDelete.mail)}
          >
            Supprimer
          </button>
        </div>
      </Modal>
    </div>
  );
}